const dashboardProposalTypes = {
  DASHBOARD_PROPOSAL_START: "INCOMPLETE_PROPOSAL_START",
  DASHBOARD_PROPOSAL_FAILURE: "INCOMPLETE_PROPOSAL_FAILURE",
  DASHBOARD_PROPOSAL_SUCCESS: "INCOMPLETE_PROPOSAL_SUCCESS",
  DASHBOARD_PROPOSAL_CHANGED: "INCOMPLETE_PROPOSAL_CHANGED",
  DASHBOARD_PROPOSAL_RESET: "INCOMPLETE_PROPOSAL_RESET",

  DASHBOARD_PROPOSAL_DELETE_START: "INCOMPLETE_PROPOSAL_DELETE_START",
  DASHBOARD_PROPOSAL_DELETE_FAILURE: "INCOMPLETE_PROPOSAL_DELETE_FAILURE",
  DASHBOARD_PROPOSAL_DELETE_SUCCESS: "INCOMPLETE_PROPOSAL_DELETE_SUCCESS",
  DASHBOARD_PROPOSAL_DELETE_CHANGED: "INCOMPLETE_PROPOSAL_DELETE_CHANGED",
  DASHBOARD_PROPOSAL_DELETE_RESET: "INCOMPLETE_PROPOSAL_DELETE_RESET",

  DASHBOARD_PROPOSAL_EXPORT_START: "INCOMPLETE_PROPOSAL_EXPORT_START",
  DASHBOARD_PROPOSAL_EXPORT_FAILURE: "INCOMPLETE_PROPOSAL_EXPORT_FAILURE",
  DASHBOARD_PROPOSAL_EXPORT_SUCCESS: "INCOMPLETE_PROPOSAL_EXPORT_SUCCESS",
  DASHBOARD_PROPOSAL_EXPORT_CHANGED: "INCOMPLETE_PROPOSAL_EXPORT_CHANGED",
  DASHBOARD_PROPOSAL_EXPORT_RESET: "INCOMPLETE_PROPOSAL_EXPORT_RESET",
};

export default dashboardProposalTypes;
